export default __webpack_public_path__ + "static/media/Logo-INM-inverted.72e33f9c.png";